<p class="text-base font-semibold leading-8 text-openflis-600">Logged Out</p>
<h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
    You have been logged out.
</h1>
<p class="mt-6 text-base leading-7 text-gray-600">
    It's a good idea to close all browser windows.
</p>
